module.exports = __webpack_public_path__ + "img/empty-calendar-event.a6306fe1.svg";